import { fonts } from 'app-v2/design-systems/typography/fonts'
import { ButtonLarge, media } from 'app/assets/styles'
import { Text, TinyText } from 'app/common/typography'
import styled from 'styled-components'

export const StyledContainer = styled.div`
    display: block;
    text-align: start;
`

export const StyledBoldText = styled(Text)`
    font-weight: bold;
    white-space: pre-line;
`

export const StyledBoldSmallText = styled(TinyText)`
    font-weight: bold;
`

export const StyledGradesContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    ${media.medium`
        flex-direction: row;
        align-items: center;
    `};
`

export const StyledFlameText = styled(Text)`
    font-family: ${fonts.flameRegular} !important;
`

export const StyledQuestion = styled.div`
    margin: 20px 0;
    & > span {
        font-family: ${fonts.flameRegular} !important;
    }
`

export const StyledAgeContainer = styled.div`
    margin-top: 40px;
    ${media.medium`
        margin-top: 50px;
    `}
`

export const StyledConditions = styled.div`
    margin: 40px 0;
    ${media.medium`
        margin: 70px 0;
    `}
`

export const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`

export const StyledButtonMedium = styled(ButtonLarge)`
    padding: 10px 50px;
    border: none;
`
